import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import { Row, Container, Col } from 'react-bootstrap';
import { Formik } from 'formik';
import FilterAccordionInput from "./AccordionFilterInput";
import FilterAccordionSelect from "./AccordionFilterSelect";

var AccordionFilterSearch = function AccordionFilterSearch(_ref) {
  var children = _ref.children,
      searchChange = _ref.searchChange,
      categories = _ref.categories,
      changeHandler = _ref.changeHandler,
      label = _ref.label;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    className: "cb-accordion__search"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      faqFilter: "all",
      searchVal: ""
    },
    enableReinitialize: true
  }, function (props) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(FilterAccordionInput, _extends({
      onChange: searchChange
    }, props, {
      label: label
    }))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(FilterAccordionSelect, {
      categories: categories,
      changeHandler: changeHandler
    })), children && /*#__PURE__*/React.createElement(Col, {
      lg: 2
    }, children));
  })));
};

export default AccordionFilterSearch;